import React from 'react';

export default class ExpandableFloatingButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false
        }
    }

    onRootClick = e => {
        this.setState({
            open: !this.state.open
        });
    }

    render() {
        return (
            <div className={`expandable-floating-button ${this.state.open ? 'open' : ''}`}>
                <div className="expandable-floating-button-items">
                    {this.props.children.map((child, idx) => (
                        <div key={idx}
                             style={{transitionDelay: (((this.props.children.length - idx - 1) * 50) + 150) + 'ms'}}>
                            {child}
                        </div>
                    ))}
                </div>

                <div className="expandable-floating-button-trigger" onClick={this.onRootClick}>
                    <svg width="100%" height="100%">
                        <g>
                            <circle cx="24" cy="17" r="2" fill="#ffffff"></circle>
                            <circle cx="24" cy="24" r="2" fill="#ffffff"></circle>
                            <circle cx="24" cy="31" r="2" fill="#ffffff"></circle>
                        </g>
                    </svg>
                </div>
            </div>
        )
    }
}